$(document).ready(function () {
    Box.Application.init({
        debug: true
    });

    // init vimeo videos
    $('iframe').each(function (index) {
        var src = $(this).attr('data-src');

        if (src != undefined && src && src.includes('vimeo')) {
            var videoID = "video" + index;
            $(this).attr('id', videoID);
            var videoIndex = '&player_id=video' + index;

            $(this).attr('data-src', src + videoIndex);
        }
    });

    window.addEventListener('CookiebotOnAccept', function (e) {
        if (Cookiebot.consent.statistics) {
            $('.cookie-statistics-active').removeClass('cookie-statistics-active')
            $('.image-placeholder').addClass('is-hidden-video')
            $('.videoWrapper').addClass('cookie-statistics-active')

            var $autoplayIframes = $('.videoWrapper iframe')
            $autoplayIframes.each(function () {
                var $this = $(this)
                $this.attr('src', $this.attr('data-src'))
            })

        }
    }, false);
});




// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/app.js